<template>
  <div class="goodsManage">
   
    <div class="search_part">
      <div class="search_box">
        <img src="./../../../../assets/img/work/manage/saleList_search.png" alt />
        <input ref="goodsInput" type="text" v-model="listQuery.name" placeholder="请输入商品名称搜索" @input="onSearch" />
        <van-icon name="cross" @click="delListQueryName" class="replay_btn" />
      </div>
    </div>


    <div class="goods_list">
      <van-sidebar v-model="active.index">
        <van-sidebar-item
          v-for="(item,i) in goodsTypeList"
          :key="i"
          :title="item.text"
          @click="changeActive(i)"
      
        />
        <div @click="editClassName('addClassName')" class="add_class_btn">+新增分类</div>
      </van-sidebar>
 
      <div class="content" ref="rightScrollBox" @scroll="onblur">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
         <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList">
        <div class="select_all_goods" :style="active.index>1?'justify-content: space-between;':''">
          <van-checkbox
            v-model="checked"
            @click="checkedAll"
            shape="square"
            checked-color="#31b158"
          >全选</van-checkbox>

          <div class="edit_btn" v-show="active.index>1" @click="editClassName">
            <img src="./../../../../assets/img/work/goods/edit_btn.png" style="width:0.18rem" alt />
            修改分类名
          </div>
        </div>
        <div style="overflow:hidden">
          <template v-if="active.index!=0||(active.index==0&&classObj)">
            <div class="goods_item" v-for="(item,i) in goodsList" :key="i">
              <div
                class="goods_item_left"
                style="padding:0.3rem 0 0.3rem; "
              >
                <div class="goods_item_title">
                  <van-checkbox
                    v-model="checkArr[i]"
                    shape="square"
                    @change="changeCheck"
                    checked-color="#31b158"
                  >
                    <div style="display:flex;width:100%" >
                      <div class="goods_item_name">{{item.name}}</div>
                      <div
                        class="goods_item_type van-ellipsis"
                        v-if="active.index==0&&item.cate_id*1"
                      >-- {{classObj[item.cate_id+'']}}</div>
                    </div>
                  </van-checkbox>
                </div>
                <div
                  :style="active.index!=0?'display:flex;padding-left:28px;flex-shrink:0;margin-top:0.1rem':'display:flex;flex-shrink:0;margin-top:0.1rem;padding-left:28px'"
                >
                  <div class="goods_item_tip goods_item_tip1" v-if="item.bale==1">
                    定装
                    <img src="./../../../../assets/img/work/open_order/order/type_dingzhuang.png" />
                  </div>
                  <div class="goods_item_tip goods_item_tip2" v-if="item.bale==2">
                    非定装
                    <img
                      src="./../../../../assets/img/work/open_order/order/type_feidingzhuang.png"
                    />
                  </div>
                  <div class="goods_item_tip goods_item_tip3" v-if="item.bale==3">
                    散装
                    <img src="./../../../../assets/img/work/open_order/order/type_sanzhuang.png" />
                  </div>
                  <div class="goods_item_tip goods_item_tip4" v-if="item.type==1">自营</div>
                  <div class="goods_item_tip goods_item_tip5" v-if="item.type==2">代卖</div>
                </div>
              </div>
              <div class="goods_item_right">
                <img
                v-if="active.index>1"
                  src="./../../../../assets/img/work/goods/goods_del.png"
                  alt
                  class="goods_del_img"
                  @click="delGoods(item)"
                />
                <img
                  @click="showActionSelect('one',item.id)"
                  src="./../../../../assets/img/work/goods/goods_move.png"
                  alt
                  class="goods_move_img"
                />
              </div>
            </div>
          </template>
        </div>

        
        </van-list> 
           </van-pull-refresh>
      </div>
   
    </div>

   
    <div class="footer_btn">
      <div class="del_btn" @click="delClassType" v-if="active.index>1">删除分类</div>
      <div class="move_btn" @click="showActionSelect('much')">批量移动商品</div>
    </div>
    <!-- 新建分类 -->

    <van-dialog
      v-model="showEditView"
      :title="editGoodsType.id?'编辑商品分类':'新建商品分类'"
      :before-close="closeDialog"
      show-cancel-button
    >
      <div class="edit_content">
        <div class="edit_item">
          <label>
            <div class="edit_box">
              <div class="edit_tip">名称</div>
              <input
                type="text"
                v-model="editGoodsType.name"
                :placeholder="editGoodsType.id?'请输入新增分类名称':'请输入分类名称'"
              />
            </div>
          </label>
        </div>
        <div class="edit_item">
          <label>
            <div class="edit_box">
              <div class="edit_tip">排序值</div>
              <input type="Number" v-model="editGoodsType.sort" placeholder="排序值越大越靠前" />
            </div>
          </label>
        </div>
      </div>
    </van-dialog>
    <!-- <van-action-sheet
      :round="false"
      v-model="showEditView"
      :title="editGoodsType.id?'编辑商品分类':'新建商品分类'"
    >
      <div class="edit_content">
        <div class="edit_item">
          <label>
            <div class="edit_box">
              分类名称:
              <input
                type="text"
                v-model="editGoodsType.name"
                :placeholder="editGoodsType.id?'请输入新增分类名称':'请输入分类名称'"
              />
            </div>
          </label>
        </div>
        <div class="edit_item">
          <label>
            <div class>
              分类权重:
              <input type="Number" v-model="editGoodsType.sort" placeholder="请输入分类权重" />
            </div>
          </label>
        </div>
        <van-button type="primary" color="#31b158" block @click="editConfirm">确定</van-button>
      </div>
    </van-action-sheet>-->
    <!-- 转移商品 -->
    <van-action-sheet
      description="请选择要转移到的商品分组"
      v-model="showActions"
      :actions="actions"
      @select="onSelect"
      cancel-text="取消"
    />
  </div>
</template>

<script>
import {
  goods_type_list,
  goods_type_del,
  goods_type_edit,
  goods_list,
  goods_transfor,
  goods_del
} from "@/api/work/manage/goodsManage.js";

const constMenuList = [
  { text: "全部", id: "" },
  { text: "未分类", id:"0" }
];
const pageSizeNum=15;//请求个数

export default {
  name: "goodsManage",
  data() {
    return {
       refreshing: false, //在加载
       loading:true,
       finished:true,
      checked: false,

      classObj: null, //菜单需求
      transforType: { type: "", id: "" }, //单人或者多人转移判断
      oldActive: {
        index: 0,
        id: "",
        name: ""
      }, //纪录active
      actions: [],
      showActions: false,
      active: { index: 0, id: "", name: "" }, //菜单索引
      showEditView: false,
      goodsTypeList: constMenuList,//基础数据
      editGoodsType: {
        name: "",
        sort: "",
        id: ""
      },
      goodsList: [],
      listQuery: {
        cate_id: "",
        name: "",
        page:1,
        pageSize:pageSizeNum
      },
      checkArr: []
    };
  },
  created() {
    this.getList();
 
    this.getMenuList();
  },
  mounted() {},
  methods: {
    //下拉刷新
     onRefresh() {
        this.finished = false;
      this.refreshing = true;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.listQuery.page = 1;
      this.listQuery.pageSize=this.goodsList.length;

      this.getList();
    },
    onSearch(){
      this.listQuery.cate_id="";
      this.active={
        index: 0,
        id: "",
        name: "全部"
      }
     this.listQuery.page = 1;
     this.goodsList=[];
     this.checked=false;
    //  this.listQuery.pageSize=this.goodsList.length;
      this.getList();

    },
    onblur(){
      this.$refs.goodsInput.blur();
    },
    delListQueryName() {
      this.listQuery.name = "";
      this.listQuery.page=1;
      this.goodsList=[];
      this.checked=false;
      this.getList();
    },
    closeDialog(actions, done) {
      if (actions == "cancel") {
        done();
        return false;
      } else {
        if (!this.editGoodsType.name) {
          this.$toast("请输入分类名称");
          done(false);
          return false;
        }
         if(this.editGoodsType.name.length>6) {
        this.$toast("请输入1-6位的分类名称");
        done(false);
        return false;
      }
        goods_type_edit(this.editGoodsType).then(res => {
          if (res.code == 200) {
            this.$toast.success(res.message);
            this.getMenuList();
            this.showEditView = false;
          }
        });
        done();
      }
    },
    //
    showActionSelect(type, id) {
      let bool = this.checkArr.every(item => {
        return !item;
      });
      if (type == "much" && bool) {
        this.$toast("请先选择商品");
        return false;
      }
      if (type == "one") {
        this.transforType = {
          type,
          id
        };
      } else {
        this.transforType = {
          type,
          id: ""
        };
      }
      this.showActions = true;
    },
    //复选逻辑
    checkedAll() {
      if (this.checkArr) {
        this.checkArr = this.checkArr.map(() => {
          return this.checked;
        });
      }

      // console.log(this.checkArr);
    },
    changeCheck() {
      let bool = this.checkArr.every(item => {
        return item;
      });

      this.checked = bool;
    },
    //转移商品

    onSelect(item) {
      let arr = [];
      if (this.transforType.type == "much") {
        for (let i = 0; i < this.checkArr.length; i++) {
          if (this.checkArr[i]) {
            arr.push(this.goodsList[i].id);
          }
        }
      } else {
        arr.push(this.transforType.id);
      }

      goods_transfor({ cate_id: item.id, goods: JSON.stringify(arr) }).then(
        res => {
          if (res.code == 200) {
            this.showActions = false;
            this.$toast.success(res.message);
            this.checked = false;
            this.listQuery.pageSize=this.goodsList.length;
            this.listQuery.page=1;
            this.getList();
          }
        }
      );
    },

    //移除商品
    delGoods(item) {
      this.$dialog
        .confirm({
          title: "移除商品",
          message:
            "确认要移除商品" + item.name + "?\n移除后商品自动归入“未分类”分组"
        })
        .then(() => {
          goods_del({ goods: JSON.stringify([item.id]) }).then(res => {
            if (res.code == 200) {
              this.$toast.success("移除成功");
              this.listQuery.pageSize=this.goodsList.length;
              this.listQuery.page=1;
              this.getList();
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },

    // 获取菜单列表
    getMenuList() {
      goods_type_list().then(res => {
        if (res.code == 200) {
         
             let  actionsArr = res.data.slice();
             actionsArr.unshift({id:"0",name:"未分类"});
             this.actions =actionsArr;
              this.goodsTypeList = constMenuList.slice(0, 2).concat(
              res.data.map(item => {
              item.text = item.name;
              return item;
            })
          );
          let obj = {};
          for (let i = 0; i < this.actions.length; i++) {
            obj[this.actions[i].id] = this.actions[i].name;
          }
          this.classObj = obj;

          for (let i = 0; i < this.goodsTypeList.length; i++) {
            if (this.goodsTypeList[i].id == this.active.id) {
              this.active.index = i;
              return false;
            }
          }
        }
      });
    },

    // 获取列表
    getList() {

      goods_list(this.listQuery)
        .then(res => {
          this.listQuery.pageSize=pageSizeNum; 
          if (res.code == 200) {
            if (!res.data||!res.data.list) {
              res.data.list = [];
            }
            if(this.listQuery.page==1){
              this.goodsList=[]; 
              this.checkArr = res.data.list.map(item => {
                 return false;
              });

            }
            else{
                this.checkArr = this.checkArr.concat(res.data.list.map(item => {
                  
                return this.checked;
                 }));
            }
      //  this.$refs.rightScrollBox.scrollTop = 0;
            this.goodsList =this.goodsList.concat(res.data.list); 
            if(this.goodsList.length == res.data.totalCount || res.data.list.length == 0){
              this.finished = true;
          }else{
              this.loading = false
              this.finished = false;
              this.listQuery.page++;
          }
          this.refreshing = false;
          }
        })
        .catch(err => {
            this.listQuery.pageSize=pageSizeNum; 
        });
    },
    //索引改变
    changeActive(index) {
      // console.log("9999999999999",this.active.index,index);
      this.oldActive = Object.assign({}, this.active);
      this.active = {
        id: this.goodsTypeList[index].id,
        name: this.goodsTypeList[index].text,
        index: index
      };

      this.listQuery.cate_id =this.active.id;
      this.listQuery.name="";
      this.listQuery.page=1;
      //  { cate_id: , name: "",page:1, };
         this.checked=false;
      this.goodsList = []
      this.getList();
      this.checkArr = this.checkArr.map(item => {
        return false;
      });
    },
    //修改分类名
    editClassName(type, item) {
      if (type == "addClassName") {
        this.editGoodsType = {
          name: "",
          id: "",
          sort: ""
        };
        this.showEditView = true;
      } else {

        this.editGoodsType = {
          name:this.goodsTypeList[this.active.index].name,
          id: this.active.id,
          sort: ""
        };
        this.showEditView = true;
      }
    },
    //提交编辑
    // editConfirm() {
    //   if (!this.editGoodsType.name) {
    //     this.$toast("请输入分类名称");
    //     return false;
    //   }
    //   console.log(this.editGoodsType.name.length)
    //   if(this.editGoodsType.name.length>8) {
    //     this.$toast("请输入1-8位的分类名称");
    //     return false;
    //   }
    //   goods_type_edit(this.editGoodsType).then(res => {
    //     if (res.code == 200) {
    //       this.$toast.success(res.message);
    //       this.getMenuList();
    //       this.showEditView = false;
    //     }
    //   });
    // },
    delClassType() {
      // console.log("9999");
      this.$dialog
        .confirm({
          title: "删除分类",
          message: "是否删除" + this.active.name + "分类，删除后不可恢复！"
        })
        .then(() => {
          // on confirm
          goods_type_del({ id: this.active.id }).then(res => {
            if (res.code == 200) {
              this.$toast.success(res.message);
              // this.active = {
              //   id: "",
              //   name: "全部商品",
              //   index: 0
              // };
          
              // console.log(this.oldActive);
              //  this.listQuery={
              //   cate_id:"",
              //   name:""
              // }
              this.active=constMenuList.slice(0,1);//全部分类
                this.listQuery.cate_id ='';
                this.listQuery.name="";
                this.listQuery.page=1;
                this.goodsList=[];
                this.getList();
                this.checkArr = this.checkArr.map(item => {
                return false;
              });
              this.getMenuList();
            }
          });
        })
        .catch(() => {
          // this.$toast('')
        });
    }
  }
};
</script>
<style lang="less">
.goodsManage {
  
    .van-pull-refresh .van-list{
      padding-bottom: 0;
    }
  
   .van-checkbox__label{
      flex-shrink: 1;
      overflow: hidden;
    }
  .van-sidebar {
    flex-shrink: 0;
    flex-grow: 0;
    flex-basis: 1.3rem;
    background-color: #f2f2f2;
   
    .van-sidebar-item {
      font-size: 0.28rem;
    
      padding: 0 0.15rem;
     height: 1.2rem; display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      color: #666666;
      font-weight: 500;
      background-color: #f2f2f2;
      .van-sidebar-item__text{
          
      text-align:center;
      }
    }
    .van-sidebar-item:nth-last-child(1) {
      color: #31b158;
    }
    .van-sidebar-item--select {
      color: #000;
      font-weight: bold;
      background-color: #fff;
    }

    //  .van-sidebar-item--select:active
    .van-sidebar-item--select::before {
      background-color: transparent;
    }
  }
  //弹框
  .van-action-sheet__header {
    text-align: left;
    padding-left: 0.3rem;
    box-sizing: border-box;
  }
}
</style>

<style lang="less" scoped>
.goodsManage {
  position: relative;
  .add_class_btn {
    position: sticky;
    bottom: 0;
    background-color: #f2f2f2;
    font-size: 0.24rem;
    line-height: 1rem;
    text-align: center;
    font-weight: 500;
    color: rgba(49, 177, 88, 1);
  }
  .goods_list {
    height: calc(100vh - 1.88rem);
    display: flex;
    justify-content: space-between;
    .content {
      flex-grow: 1;
      flex-shrink: 1;
      background: #fff;
      height: calc(100vh - 2.88rem);
      overflow-y: auto;
    }
    .empty_data {
      font-size: 0.24rem;
      text-align: center;
      color: #999;
      padding-top: 0.5rem;
    }
  }
  .select_all_goods {
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 999;
    padding: 0.28rem 0;
    margin: 0 0.21rem 0 0.2rem;
    border-bottom: 1px solid #e6e6e6;
    box-sizing: border-box;
    font-size: 0.24rem;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    display: flex;
    align-items: center;
    .edit_btn {
      background: rgba(49, 177, 88, 1);
      border-radius: 4px;
      font-size: 0.24rem;
      font-weight: 500;
      padding: 0.1rem 0.15rem;
      display: flex;
      align-items: center;
      color: rgba(255, 255, 255, 1);
      img {
        margin-right: 0.12rem;
      }
    }
  }

  .goods_item {
    // padding: 0.2rem 0;
    border-bottom: 1px solid #e6e6e6;
    box-sizing: border-box;
    margin: 0 0.21rem 0 0.2rem;
    display: flex;
    align-items: center;
    .goods_item_left {
      flex-grow: 0;
      flex-shrink: 1;
      width: 100%;
      box-sizing: border-box;
      overflow: hidden;
      .goods_item_title {
        // margin-top: 0.1rem;
        font-size: 0.32rem;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        flex-shrink: 1;
        overflow: hidden;
        .goods_item_name {
          // max-width: 2.5rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .goods_item_type {
          font-size: 0.24rem;
          flex-shrink: 0;
          margin-left: 0.2rem;
          width: 1.3rem;
          color: #999;
          vertical-align: baseline;
        }
      }
      .goods_item_tip {
        line-height: 0.32rem;
        font-size: 0.24rem;
        border-radius: 0.16rem;
        padding: 0 0.12rem;
        display: flex;
        align-items: center;
        flex-shrink: 0;
        img {
          width: 0.18rem;
          margin-left: 0.1rem;
        }
      }
      .goods_item_tip1 {
        background-color: #daeffb;
        color: #1d78c5;
      }
      .goods_item_tip2 {
        background: rgba(251, 237, 218, 1);
        color: #bf8535;
      }
      .goods_item_tip3 {
        background: rgba(218, 251, 219, 1);
        color: #4b9c64;
      }
      .goods_item_tip4 {
        background: rgba(28, 192, 233, 0.3);
        color: #268ea7;
        margin-left: 0.1rem;
      }
      .goods_item_tip5 {
        background: rgba(233, 153, 28, 0.3);
        color: #c6601c;
        margin-left: 0.1rem;
      }
    }
    .goods_item_right {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      padding-left: 0.3rem;
      .goods_del_img {
        width: 0.36rem;
         margin-right: 0.3rem;
      }
      .goods_move_img {
       
        width: 0.36rem;
      }
    }
  }
  //弹框
  .edit_content {
    padding-top: 0.1rem;
    .edit_item {
      // padding-bottom: 0.2rem;
      label {
        display: block;
        div {
          height: 0.5rem;
          margin: 0.3rem 0.3rem 0;
          line-height: 0.5rem;
          box-sizing: content-box;
        }
        .edit_box {
          display: flex;
          align-items: center;
          .edit_tip {
            width: 1rem;
            flex-shrink: 0;
            text-align-last: justify;
            flex-grow: 0;
            margin: 0 0.11rem 0 0;
          }
          // border-bottom: 1px solid #ccc;
          input {
            width: 60%;
            flex-shrink: 1;
            flex-grow: 1;
            padding-left: 0.2rem;
            line-height: 0.5rem;
            box-sizing: border-box;
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(230, 230, 230, 1);
            // border: 1px solid ;
          }
        }
      }
    }
    .edit_item:nth-of-type(2) {
      padding-bottom: 0.6rem;
    }
  }
  .search_part {
    padding: 0.1rem 0 0.1rem;
    background: #fff;
  }
  .search_box {
    background: rgba(242, 242, 242, 1);
    position: relative;
    display: flex;
    align-items: center;
    height: 0.8rem;
    line-height: 0.8rem;
    img {
      position: absolute;
      top: 0.22rem;
      left: 0.2rem;
      width: 0.32rem;
      height: 0.32rem;
    }
    .replay_btn {
      flex-shrink: 0;
      margin: 0 0.2rem;
    }
    input {
      line-height: 0.8rem;
      height: 0.8rem;
      width: 100%;
      flex-grow: 1;
      flex-shrink: 1;
      box-sizing: border-box;
      background: rgba(242, 242, 242, 1);
      border-radius: 4px;
      padding-left: 0.67rem;
    }
  }
  .footer_btn {
    position: fixed;
    bottom: 0;
    right: 0;
    width: 6.2rem;
    margin-left: 1.3rem;
    height: 1rem;
    display: flex;
    font-size: 0.36rem;
    line-height: 1rem;

    .del_btn {
      width: 50%;
      flex-grow: 1;
      text-align: center;
      font-weight: 500;
      color: rgba(102, 102, 102, 1);
      line-height: 1rem;
      height: 1rem;
      background-color: #cccccc;
    }
    .move_btn {
      width: 50%;
      flex-grow: 1;
      text-align: center;
      color: rgba(255, 255, 255, 1);
      line-height: 1rem;
      height: 1rem;
      background-color: #31b158;
    }
  }
}
</style>